import { render, staticRenderFns } from "./columnTodo.vue?vue&type=template&id=d712e90e&scoped=true&"
import script from "./columnTodo.vue?vue&type=script&lang=js&"
export * from "./columnTodo.vue?vue&type=script&lang=js&"
import style0 from "./columnTodo.vue?vue&type=style&index=0&id=d712e90e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d712e90e",
  null
  
)

export default component.exports